<div class="main-page">
  <!-- <app-header></app-header> -->
  <app-common-header></app-common-header>
  <div class="container">
    <ngx-ui-loader fgsSize="50" [fgsType]="spinnerType"></ngx-ui-loader>
    <div class="login-page-top">
      <div class="innerPage login-page login-card">
        <div class="login-screen-area">
          <h1 class="nav-divnk">Login</h1>
        </div>
        <div class="storefront-icon-container">
          <i class="fas fa-store storefront-icon"></i>
        </div>
        <div class="content-part logo-container">
          <img src="assets/logo-5.png" alt="Ravel Merchant Logo" class="logo-image" />
        </div>
        <form
          class="form-signin"
          [formGroup]="form"
          (ngSubmit)="onSubmit(form.value)"
        >
          <div class="input-container">
            <div class="form-group input-wrapper">
              <div class="input-icon">
                <i class="fas fa-envelope"></i>
              </div>
              <input
                type="email"
                class="form-control inputBox modern-input"
                formControlName="email"
                placeholder="Email"
                [ngClass]="{ 'is-invalid': submitted && f.email.errors, 'has-value': form.get('email')?.value }"
              />
              <div
                *ngIf="submitted && f.email.errors"
                class="invalid-feedback error-message"
              >
                <div *ngIf="f.email.errors.required">Email is required</div>
                <div *ngIf="f.email.errors.email">
                  Email must be a valid email address
                </div>
              </div>
            </div>
            <div class="form-group mb-0 input-wrapper password-wrapper">
              <div class="input-icon">
                <i class="fas fa-lock"></i>
              </div>
              <input
                [type]="showPassword ? 'text' : 'password'"
                class="form-control inputBox modern-input"
                formControlName="password"
                placeholder="Password"
                [ngClass]="{ 'is-invalid': submitted && f.password.errors, 'has-value': form.get('password')?.value }"
              />
              <button
                type="button"
                class="password-toggle-btn"
                (click)="togglePasswordVisibility()"
                aria-label="Toggle password visibility"
              >
                <i
                  [class]="
                    showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'
                  "
                ></i>
              </button>
              <div
                *ngIf="submitted && f.password.errors"
                class="invalid-feedback error-message"
              >
                <span *ngIf="f.password.errors.required"
                  >Password is required</span
                >
                <span *ngIf="f.password.errors.minlength"
                  >Password must be at least 6 characters</span
                >
              </div>
            </div>
            <div class="form-options">
              <label class="remember-me-label">
                <input
                  [(ngModel)]="rememberMe"
                  formControlName="rememberMe"
                  type="checkbox"
                  class="remember-checkbox"
                />
                <span class="remember-text">Remember me</span>
              </label>
              <a routerLink="/forgot-password" class="forgot-pass-link">
                Forgot Password?
              </a>
            </div>
            <div class="adjust-div sign-in-button">
              <button
                type="button"
                class="sign-in-btn"
                (click)="onLoginClick()"
              >
                <span class="btn-text">Sign in</span>
                <i class="fas fa-arrow-right btn-icon"></i>
              </button>
            </div>
          </div>
        </form>
        <div class="social-divider">
          <span class="divider-text">Continue with</span>
        </div>
        <div class="form-field social-buttons">
          <button
            (click)="facebookLogin()"
            type="button"
            class="social-btn facebook-btn"
          >
            <i class="fab fa-facebook-f social-icon"></i>
            <span class="social-text">Facebook</span>
          </button>
          <button
            (click)="googleLogin()"
            type="button"
            class="social-btn google-btn"
          >
            <i class="fab fa-google social-icon"></i>
            <span class="social-text">Google</span>
          </button>
          <button
            (click)="appleLogin()"
            type="button"
            class="social-btn apple-btn"
          >
            <i class="fab fa-apple social-icon"></i>
            <span class="social-text">Apple</span>
          </button>
        </div>
        <!--                <p><a href="https://ravel.faith/policies/ravel-terms/" target="_blank">Terms of Services </a><span> and </span><a href="https://ravel.faith/policies/privacy-policy/" target="_blank">Private Policy</a></p> -->
        <div class="policy">
          <label class="policy-label">
            <input
              type="checkbox"
              [checked]="form.get('acceptTerms')?.value"
              (change)="onAcceptTermsChange($event)"
              class="policy-checkbox"
            />
            <span class="policy-text">
              By continuing, you agree to Ravel's<br />
              <span class="policy-links">
                <a
                  href="https://ravel.faith/policies/ravel-terms/"
                  target="_blank"
                  class="policy-link"
                  >Terms of Service</a
                >
                and
                <a
                  href="https://ravel.faith/policies/privacy-policy/"
                  target="_blank"
                  class="policy-link"
                  >Privacy Policy</a
                >
              </span>
            </span>
          </label>
          <div
            *ngIf="submitted && f.acceptTerms.errors?.required"
            class="terms-error"
          >
            You must accept the terms and privacy policy.
          </div>
        </div>
        <div class="signup-section">
          <p class="signup-text">
            Don't have an account?
            <span class="signup-link" (click)="signup()">Sign-Up FREE!</span>
          </p>
        </div>
      </div>

      <!-- <div class="agree-text">
               <div class="form-check">
                  <div class="form-check-input-inner">
                     <input [checked]="isChecked" (change)="checkCheckBoxvalue($event)" type="checkbox"
                        class="form-check-input" id="exampleCheck1">
                     <label class="form-check-label" for="exampleCheck1">By Signing Up you agree to the
                        <span>
                           <a href="https://ravel.faith/policies/ravel-terms/" target="_blank">Terms of Services </a>
                        </span>
                        and
                        <span>
                           <a href="https://ravel.faith/policies/privacy-policy/" target="_blank">Private
                              Policy</a>
                        </span>
                     </label>
                  </div>
               </div>
            </div> -->
    </div>
  </div>
</div>
